const VoucherType = {
  VOUCHER: 1,
  COUPON: 2,
  PROMOTION: 3
}
export default VoucherType
